module.exports = __webpack_public_path__ + "static/media/1.434afb43.jpg";